// Route guard (audit T3.1/UI-03). Admin pages (/settings, /team, /automation)
// used to render the full admin UI — SMTP forms, invites, webhook builder — to
// any authenticated user who typed the URL; the nav hid them but nothing blocked
// direct navigation. This gates them on the SAME isAdminUser() check the nav
// uses, showing a 403 instead of the admin surface. The server already blocks
// mutations; this closes the info-disclosure hole (admin UI + its GET data).
import type { ReactNode } from 'react';
import { useAuth, isAdminUser } from '@/auth/AuthContext';
import { ForbiddenPage } from '@/pages/ForbiddenPage';

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!isAdminUser(user)) return <ForbiddenPage />;
  return <>{children}</>;
}
